// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQueryWithOffset } from '@hooks/other/useQueryWithOffset';
import { UseQueryResult } from '@tanstack/react-query';
import { RegistrarService } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Registrar';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';

const useRegistrarService: () => UseQueryResult<
  TemplateContract<RegistrarService> | null,
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator, party } = useParties();
  return useQueryWithOffset({
    queryKey: ['queryRegistryRegistrarService', operator, party],
    queryFn: async (_, offset) => {
      return ledgerApi.queryRegistryRegistrarService(offset, operator, party);
    },
  });
};

export default useRegistrarService;
